module.exports = __webpack_public_path__ + "img/icon-refer.29e867cf.svg";